import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoItsForSection() {
  const forList = ['Grandmothers who are currently blocked or "on ice" with their adult children.', 'Women who are tired of crying over photos and want a practical, dignified plan.', 'Those who are willing to trade "being right" for "being present."', 'Grandparents who want to be a blessing to their family, not a burden.'];
  const notForList = ['Those looking for legal "Grandparent Rights" advice or litigation strategies.', 'People unwilling to look at their own role in the family dynamic.', 'Situations involving active abuse or court-ordered restraining orders.'];
  return <section className="py-20 bg-brand-cream" data-id="element-125">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl" data-id="element-126">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-127">
          {/* Who This Is For */}
          <div className="bg-white rounded-3xl p-8 md:p-10 shadow-sm border border-brand-sage" data-id="element-128">
            <h3 className="text-2xl font-bold mb-8 flex items-center gap-3" data-id="element-129">
              <span className="w-8 h-8 rounded-full bg-brand-sage flex items-center justify-center text-brand-navy" data-id="element-130">
                ✓
              </span>
              Who This Is For
            </h3>
            <ul className="space-y-6" data-id="element-131">
              {forList.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-132">
                  <CheckCircle2 className="w-6 h-6 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-133" />
                  <span className="text-brand-body leading-relaxed" data-id="element-134">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Who This Is Not For */}
          <div className="bg-brand-rose/30 rounded-3xl p-8 md:p-10 shadow-sm border border-brand-rose/50" data-id="element-135">
            <h3 className="text-2xl font-bold mb-8 flex items-center gap-3" data-id="element-136">
              <span className="w-8 h-8 rounded-full bg-brand-rose flex items-center justify-center text-brand-navy" data-id="element-137">
                ✕
              </span>
              Who This Is Not For
            </h3>
            <ul className="space-y-6" data-id="element-138">
              {notForList.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-139">
                  <XCircle className="w-6 h-6 text-brand-navy/40 flex-shrink-0 mt-0.5" data-id="element-140" />
                  <span className="text-brand-body leading-relaxed" data-id="element-141">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}